import './style.css';
import axios from 'axios';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import localStorage from '../../../../utils/localStorage';
import StyledTable from '../../../../commons/styles/table';
import { API_DASHBOARD } from '../../../../commons/api';
import {
  Row,
  Col,
  Form,
  Slider,
  Button,
  InputNumber,
  DatePicker,
  message,
  Radio,
  Typography,
} from 'antd';
import { useParams } from 'react-router-dom';

const { Title } = Typography;

const SmartMotorControl = (props) => {
  const minValue = 0;
  const maxValue = 50;

  const [mode, setMode] = useState('');
  const [userProfile, setUserProfile] = useState(props.userProfile);
  const [parameterValue, setParameterValue] = useState(undefined);

  const hookParams = useParams();

  useEffect(() => {
    try {
      console.log(hookParams.name);
    } catch (error) {
      console.error(error);
    }
  }, [hookParams.name]);

  useEffect(() => {
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }
  }, [props.userProfile]);

  const handleSubmit = () => {
    if (mode === '' || parameterValue === undefined) {
      message.error('Please provide setpoints');
      return;
    }

    const payload = {
      motorSpeed: parameterValue,
      status: mode
    };

    formSubmission(payload);
  };

  const formSubmission = (payload) => {
    const accessToken = localStorage.get('accessToken');

    axios({
      method: 'POST',
      url: `${API_DASHBOARD.VibratingMotorForm}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    })
      .then((response) => {
        message.success('Submitted successfully');
        return response;
      })
      .catch((error) => {
        console.error(error);
        message.error('Submission failed');
      });
  };

  const columns = [
    {
      title: 'SI.No',
      dataIndex: 'sno',
      key: 'sno'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status'
    },
    {
      title: 'Frequency',
      dataIndex: 'frequency',
      key: 'frequency'
    },
    {
      title: 'Submitted Timestamp',
      dataIndex: 'timestamp',
      key: 'timestamp'
    },
    {
      title: 'User Name',
      dataIndex: 'userName',
      key: 'userName'
    }
  ];

  return (
    <div style={{ padding: '40px' }}>
      <Row gutter={[32, 32]}>
        {/* Left Panel */}
        <Col xs={24} md={12}>
          <Title level={4}>Smart Motor Control</Title>
          <Form layout="vertical">
            <Form.Item label="Select Mode">
              <Radio.Group
                onChange={(e) => setMode(e.target.value)}
                buttonStyle="solid"
                value={mode}
              >
                <Radio.Button value="start">START</Radio.Button>
                <Radio.Button value="stop">STOP</Radio.Button>
              </Radio.Group>
            </Form.Item>

            <Form.Item label="Select Frequency">
              <Row align="middle">
                <Col span={18}>
                  <Slider
                    disabled={mode !== 'start'}
                    min={minValue}
                    max={maxValue}
                    value={mode === 'stop' ? 0 : parameterValue}
                    onChange={(value) => setParameterValue(value)}
                    tooltip={{ formatter: (value) => `${value}` }}
                  />
                </Col>
                <Col span={6}>
                  <InputNumber
                    min={minValue}
                    max={maxValue}
                    value={mode === 'stop' ? 0 : parameterValue}
                    onChange={(value) => setParameterValue(value)}
                    style={{ width: '100%' }}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                shape="round"
                onClick={handleSubmit}
                block
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>

        {/* Right Panel */}
        <Col xs={24} md={12}>
          <Row justify="space-between" align="middle" style={{ marginBottom: '16px' }}>
            <Col>
              <Title level={5}>Submission History</Title>
            </Col>
            <Col>
              <DatePicker />
            </Col>
          </Row>
          <StyledTable
            size="small"
            columns={columns}
            // Add your dataSource prop here if available
          />
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile
});

export default connect(mapStateToProps)(SmartMotorControl);
